/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Regenerate_Token_LabelInputs */



/**
* | output |
* | --- |
* | "Regenerate Token" |
*
* @param {Scim_Regenerate_Token_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_regenerate_token_label = /** @type {((inputs?: Scim_Regenerate_Token_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Regenerate_Token_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Token erneuern")
	return /** @type {LocalizedString} */ ("Regenerate Token")
});